import React from 'react';
import { SKIN_TAGS } from '../../data/store';

export default function StepSkin({ data, onChange }) {
  const toggle = (tag) => {
    const current = data.tags || [];
    onChange({ tags: current.includes(tag) ? current.filter(t => t !== tag) : [...current, tag] });
  };

  return (
    <div className="space-y-6">
      <p className="font-sans text-sm text-slate-500">Select all that apply to your skin today.</p>
      
      <div className="flex flex-wrap gap-3">
        {SKIN_TAGS.map(tag => {
          const active = (data.tags || []).includes(tag);
          return (
            <button
              key={tag}
              onClick={() => toggle(tag)}
              className={`rounded-full font-sans text-sm font-medium px-5 py-3 transition-all active:scale-95 ${
                active 
                  ? 'bg-slate-900 text-white' 
                  : 'glass-input text-slate-700'
              }`}
            >
              {tag}
            </button>
          );
        })}
      </div>

      <div className="glass-card rounded-[2rem] p-6">
        <label className="block font-sans text-xs font-semibold uppercase tracking-widest text-slate-400 mb-3">
          Daily Journal
        </label>
        <textarea
          value={data.notes || ''}
          onChange={(e) => onChange({ notes: e.target.value })}
          placeholder="Skin looked tight + glowy… didn't sleep well… less puffiness…"
          rows={5}
          className="w-full font-sans text-sm text-slate-800 bg-transparent resize-none focus:outline-none placeholder:text-slate-400"
        />
      </div>
    </div>
  );
}